<template>
  <div v-if="isVisible" class="subscription-details-modal">
    <div class="modal-backdrop" @click="$emit('closeEmailModal')"></div>

    <div class="modal-card">
      <div class="modal-header">
        <h3>Szczegóły subskrypcji</h3>
        <button class="btn-icon" @click="$emit('closeEmailModal')" title="Zamknij">
          <img src="@/assets/icons/x.svg" alt="zamknij">
        </button>
      </div>

      <div class="table-wrapper" v-if="currentSubscriber && currentSubscriber.subscription">
        <table>
          <tr>
            <th>Subskrypcja</th>
            <td>{{ currentSubscriber.subscription.subscription.name }}</td>
          </tr>
          <tr>
            <th>E-mail</th>
            <td>{{ currentSubscriber.email }}</td>
          </tr>
          <tr>
            <th>Dodatkowi użytkownicy</th>
            <td>{{ currentSubscriber.subscription.users }}</td>
          </tr>
          <tr>
            <th>Data wygaśnięcia</th>
            <td>{{ currentSubscriber.subscription.date }}</td>
          </tr>
          <tr>
            <th>Wysłane SMS</th>
            <td>{{ currentSubscriber.sent_sms ? currentSubscriber.sent_sms : '0' }}</td>
          </tr>
          <tr>
            <th>Do zapłaty (SMS)</th>
            <td>{{ currentSubscriber.sent_sms ? currentSubscriber.sent_sms * currentSubscriber.subscription.additionalSMS : '0' }} zł</td>
          </tr>
        </table>
      </div>

      <div class="empty-state" v-else>
        Brak danych do wyświetlenia.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionDetailsModal',
  props: ['isVisible', 'currentSubscriber'],
};
</script>

<style scoped lang="scss">
.subscription-details-modal {
  position: fixed;
  inset: 0;
  z-index: 120;
}

.modal-backdrop {
  position: absolute;
  inset: 0;
  background-color: rgba(17, 24, 39, 0.65);
  backdrop-filter: blur(2px);
}

.modal-card {
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(100% - 24px);
  max-width: 620px;
  transform: translate(-50%, -50%);
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;

  h3 {
    margin: 0;
    color: #1f2937;
    font-size: 1.9rem;
    font-weight: 700;
  }
}

.table-wrapper {
  padding: 14px;
  overflow-x: auto;
}

table {
  width: 100%;
  min-width: 420px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

th,
td {
  border-bottom: 1px solid #f1f5f9;
  padding: 10px 12px;
  text-align: left;
  font-size: 1.4rem;
  vertical-align: top;
}

th {
  width: 40%;
  background: #f9fafb;
  color: #374151;
  font-weight: 700;
}

td {
  color: #1f2937;
  word-break: break-word;
}

tr:last-child th,
tr:last-child td {
  border-bottom: none;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.empty-state {
  padding: 20px 16px;
  color: #9ca3af;
  font-size: 1.5rem;
  text-align: center;
}

@media (max-width: 480px) {
  .modal-card {
    border-radius: 8px;
  }

  .modal-header h3 {
    font-size: 1.7rem;
  }

  .table-wrapper {
    padding: 10px;
  }

  th,
  td {
    font-size: 1.3rem;
    padding: 8px 10px;
  }
}
</style>